export default __webpack_public_path__ + "static/media/decay.31e3f706.png";